<div class="col-24">
    <li *ngFor="let comment of comments; let commentIndex = index" class="pb-2 text-break"
        [innerHTML]="parseComment(comment)">
    </li>
</div>